<template>
	<div
		class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-2"
	>
		<div v-if="auctionResultsIsActive">
			<div>
				<h2 class="font-bold text-3xl text-gray-500 mb-4">
					{{ __("Your results for the last auction on") }}
					{{ auctionDate }}
				</h2>
				<auction-result :auction="auction" :results="results" />
			</div>
		</div>
		<div v-else>
			<div class="flex justify-between mb-3">
				<p class="font-semibold text-xl text-gray-900 flex justify-start">
					<span
						v-if="auctionBiddingIsActive"
						class="text-red flex justify-start"
					>
						<ui-icon
							name="alert-triangle"
							class="w-6 h-6 mt-1 mr-2 text-red-400"
							aria-hidden="true"
						/>
						<span>{{ __("Bietphase endet in") }}</span>
					</span>
					<span v-else>
						{{ __("Bietphase startet in") }}
					</span>
					<span
						id="countdown"
						class="ml-2"
						:class="auctionBiddingIsActive ? 'text-red' : ''"
						>{{ timer }}</span
					>
				</p>
				<div>
					<ui-button
						:type="
							auctionHasBids
								? showBidList
									? 'primary-reverted'
									: 'primary'
								: 'primary-disabled'
						"
						:class="showBidList ? 'bg-white' : ''"
						:disabled="!auctionHasBids"
						v-on:click="toggleBidList()"
					>
						{{ bidsListLinkCaption }}
					</ui-button>
				</div>
			</div>
			<div v-if="showBidList">
				<div>
					<h2 class="font-bold text-3xl text-gray-900 mb-4">
						{{
							__("Ihre abgegebenen Preise für die heutigen Auktionsangebote")
						}}
					</h2>
					<auction-edit
						:auction="auction"
						:offers="offersWithBids"
						:activeFutures="activeFutures"
					/>
				</div>
			</div>
			<div v-else>
				<div
					class="flex flex-wrap lg:flex-nowrap gap-y-4 md:space-y-0 justify-start items-center mb-4 gap-x-6"
				>
					<h2 class="font-bold text-3xl underline text-gray-900">
						{{ __("Heutige Auktionsangebote") }}
					</h2>
				</div>

				<div
					class="grid gap-y-4 gap-x-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-4"
				>
					<auction-card
						v-for="offer in offers"
						:offer="offer"
						:auction="auction"
						:key="offer.trade + offer.id"
						:auctionBiddingIsActive="auctionBiddingIsActive"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}
export default {
	props: {
		offers: {
			type: Array,
			required: true,
		},
		auction: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		auctionIndexState: {
			type: String,
			required: true,
		},
		showList: {
			type: Boolean,
			required: true,
		},
		results: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			now: new Date(),
			biddingStartTime: new Date(this.auction.bidding_starts_at),
			biddingEndTime: new Date(this.auction.bidding_ends_at),
			timer: null,
			showBidList: this.showList,
		};
	},
	methods: {
		startTimer: function () {
			const timeNow = new Date().getTime();
			var timeDifference = this.biddingStartTime - timeNow;
			if (this.auctionBiddingIsActive) {
				timeDifference = this.biddingEndTime - timeNow;
			}
			const millisecondsInOneSecond = 1000;
			const millisecondsInOneMinute = millisecondsInOneSecond * 60;
			const millisecondsInOneHour = millisecondsInOneMinute * 60;
			const millisecondsInOneDay = millisecondsInOneHour * 24;
			const differenceInDays = timeDifference / millisecondsInOneDay;
			const remainderDifferenceInHours =
				(timeDifference % millisecondsInOneDay) / millisecondsInOneHour;
			const remainderDifferenceInMinutes =
				(timeDifference % millisecondsInOneHour) / millisecondsInOneMinute;
			const remainderDifferenceInSeconds =
				(timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond;
			const remainingDays = Math.floor(differenceInDays);
			const remainingHours = Math.floor(remainderDifferenceInHours);
			const remainingMinutes = Math.floor(remainderDifferenceInMinutes);
			const remainingSeconds = Math.floor(remainderDifferenceInSeconds);
			this.timer =
				remainingHours +
				"h " +
				"" +
				remainingMinutes +
				"m " +
				"" +
				remainingSeconds +
				"s";
		},
		toggleBidList() {
			this.showBidList = !this.showBidList;
		},
	},
	mounted() {
		setInterval(() => {
			this.startTimer();
		}, 1000);
	},
	computed: {
		auctionBiddingIsActive() {
			if (this.auction !== null && this.auction.bidding_is_active) {
				return true;
			}
			return false;
		},
		auctionPreBiddingIsActive() {
			if (this.auction !== null && this.auctionIndexState == "PREBIDDING") {
				return true;
			}
			return false;
		},
		auctionResultsIsActive() {
			if (this.auction !== null && this.auctionIndexState == "RESULTS") {
				return true;
			}
			return false;
		},
		offersWithBids() {
			let offersWithBids = [];
			this.offers.forEach((offer, index) => {
				if (offer.auctionBids.length > 0) {
					offersWithBids.push(offer);
				}
			});
			return offersWithBids;
		},
		auctionHasBids() {
			return this.offersWithBids.length > 0;
		},
		bidsListLinkCaption() {
			return this.showBidList ? __("Zur Auktion") : __("Ihre Gebote");
		},
		auctionDate() {
			var date = new Date(this.auction.bidding_starts_at);
			return (
				padTo2Digits(date.getDate()) +
				"." +
				padTo2Digits(date.getMonth() + 1) +
				"." +
				date.getFullYear()
			);
		},
	},
};
</script>
